import React, { useState, useCallback, useEffect, useRef, useImperativeHandle, forwardRef, useMemo } from 'react';
import { CellMeasurer, CellMeasurerCache, List } from '../../../library/LinearList/refresh-virtualized';
import useSyncSingleAndDoubleClick from '@web-common/hooks/useSyncDoubleClick';
import useCreateCallbackForEvent from '../../../../hooks/useCreateCallbackForEvent';
import { debounce, throttle } from 'lodash';
import styles from './cardList.module.scss';
import { useUpdateEffect } from 'ahooks';
import useStateRef from '@web-mail/hooks/useStateRef';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import { systemIsMac } from '@web-mail/util';
import { TongyongZhankaiXia } from '@sirius/icons';
import Checkbox from '@lingxi-common-component/sirius-ui/Checkbox';
const defaultCardCom = () => React.createElement(React.Fragment, null);
const defaultGetUniqKey = (index) => index + '';
const defaultCardWrap = (props) => React.createElement("div", Object.assign({}, props));
const defaultArray = [];
const SCROLL_OVER_CLASSNAME = styles.cardlistScrollOver;
const DEFAULT_REAL_LIST_CLASSNAME = systemIsMac() ? styles.mListWrapper : styles.mListWrapperWin;
function CardList(props, ref) {
    const { height, width, total, rowHeight, onScroll, activeId, cardMargin = 1, data, card: CardCom = defaultCardCom, cardWrap: CardWrap = defaultCardWrap, getUniqKey = defaultGetUniqKey, cardGroupDecorate, onSelect, onUnSelect, onDoubleClick, onContextMenu, topExtraData = defaultArray, isMultiple = false, onChecked, selectIsCapture = false, scrollTop, batchSize, threshold, containerStyle, className, overscanRowCount, pullRefreshLoadingHeight, loadMoreLoadingHeight, noMoreRender, pullRefreshRender, loadMoreLoadingRender, noRowsRenderer, onPullRefresh, onLoadMore, loadMoreLoadingFailRender, initLoadLoadingFailRender, listFouceRender, useRealList = false, realListPager = null, realListClassName = '', isRefresh, onContentInsufficientHeight, onGroupCollapse, groupCollapse = defaultArray, decoratesWrapClassName = '', } = props;
    const listref = useRef(null);
    const realListRef = useRef(null);
    const [fixDec, setFixDec] = useState();
    const scrollTopRef = useRef(0);
    const onGroupCollapseRef = useCreateCallbackForEvent(onGroupCollapse);
    const scrollToPositionRef = useCreateCallbackForEvent((st) => {
        var _a, _b;
        if (useRealList) {
            if (realListRef.current) {
                realListRef.current.scrollTop = st;
            }
        }
        else {
            if ((_a = listref.current) === null || _a === void 0 ? void 0 : _a.scrollToPosition) {
                (_b = listref.current) === null || _b === void 0 ? void 0 : _b.scrollToPosition(st);
            }
        }
    });
    useEffect(() => {
        if (scrollTop == 0 && scrollTop != scrollTopRef.current) {
            scrollToPositionRef(scrollTop);
            scrollTopRef.current = scrollTop;
        }
    }, [scrollTop]);
    const activeIdMap = useMemo(() => {
        if (activeId && activeId.length) {
            const map = {};
            activeId.forEach(item => {
                map[item] = !0;
            });
            return map;
        }
        else {
            return {};
        }
    }, [activeId]);
    const dataKey = useMemo(() => {
        if (data && (data === null || data === void 0 ? void 0 : data.length)) {
            try {
                return data.map((item, index) => getUniqKey(index, item)).join('-');
            }
            catch (e) {
                console.error('[error cardList OverScreen]', e);
            }
        }
        return '';
    }, [data, getUniqKey]);
    const cardKey2SataMap = useMemo(() => {
        if (data && data.length) {
            const map = {};
            data.forEach((item, index) => {
                map[getUniqKey(index, item)] = item;
            });
            return map;
        }
        else {
            return {};
        }
    }, [data]);
    const [decorates, fixedList, groupCollapseMap] = useMemo(() => {
        const idMap = {};
        const groupCollapseMap = {};
        const fixedDecList = [];
        if (cardGroupDecorate && cardGroupDecorate.length) {
            const list = [];
            cardGroupDecorate.forEach((fn, cgIndex) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                const prev = cgIndex < 0 ? null : list[list.length - 1];
                const prevIndex = prev || 0;
                const decorateRenderResult = fn(data, prevIndex);
                if (decorateRenderResult) {
                    if (Array.isArray(decorateRenderResult)) {
                        decorateRenderResult.forEach(decorate => {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            const { index, fixed, key } = decorate;
                            const uniqKey = getUniqKey(index, data[index]);
                            if (groupCollapse.includes(key)) {
                                groupCollapseMap[uniqKey] = key || '';
                            }
                            if (fixed && !groupCollapseMap[uniqKey]) {
                                fixedDecList.push({
                                    cardKey: uniqKey,
                                    decorate: decorate,
                                });
                            }
                            list.push(index + 1);
                            if (idMap[uniqKey]) {
                                (decorate === null || decorate === void 0 ? void 0 : decorate.position) == 'top' ? (_b = (_a = idMap[uniqKey]) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.push(decorate) : (_d = (_c = idMap[uniqKey]) === null || _c === void 0 ? void 0 : _c.bottom) === null || _d === void 0 ? void 0 : _d.push(decorate);
                            }
                            else {
                                idMap[uniqKey] = {
                                    top: [],
                                    bottom: [],
                                };
                                (decorate === null || decorate === void 0 ? void 0 : decorate.position) == 'top' ? (_f = (_e = idMap[uniqKey]) === null || _e === void 0 ? void 0 : _e.top) === null || _f === void 0 ? void 0 : _f.push(decorate) : (_h = (_g = idMap[uniqKey]) === null || _g === void 0 ? void 0 : _g.bottom) === null || _h === void 0 ? void 0 : _h.push(decorate);
                            }
                        });
                    }
                    else {
                        const { index, fixed, key } = decorateRenderResult;
                        const uniqKey = getUniqKey(index, data[index]);
                        if (groupCollapse.includes(key)) {
                            groupCollapseMap[uniqKey] = key || '';
                        }
                        if (fixed && !groupCollapseMap[uniqKey]) {
                            fixedDecList.push({
                                cardKey: uniqKey,
                                decorate: decorateRenderResult,
                            });
                        }
                        list.push(index + 1);
                        if (idMap[uniqKey]) {
                            (decorateRenderResult === null || decorateRenderResult === void 0 ? void 0 : decorateRenderResult.position) == 'top' ? (_b = (_a = idMap[uniqKey]) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.push() : (_d = (_c = idMap[uniqKey]) === null || _c === void 0 ? void 0 : _c.bottom) === null || _d === void 0 ? void 0 : _d.push(decorateRenderResult);
                        }
                        else {
                            idMap[uniqKey] = {
                                top: [],
                                bottom: [],
                            };
                            (decorateRenderResult === null || decorateRenderResult === void 0 ? void 0 : decorateRenderResult.position) == 'top' ? (_f = (_e = idMap[uniqKey]) === null || _e === void 0 ? void 0 : _e.top) === null || _f === void 0 ? void 0 : _f.push(decorateRenderResult) : (_h = (_g = idMap[uniqKey]) === null || _g === void 0 ? void 0 : _g.bottom) === null || _h === void 0 ? void 0 : _h.push(decorateRenderResult);
                        }
                    }
                }
            });
            fixedDecList.sort((pre, cur) => pre.index - cur.index);
            setTimeout(() => {
                throttleScanFixedDec(scrollTopRef.current);
            }, 0);
        }
        return [idMap, fixedDecList, groupCollapseMap];
    }, [data, cardGroupDecorate, groupCollapse]);
    const cardHiddenMap = useMemo(() => {
        const map = {};
        let lock = null;
        data.forEach((item, index) => {
            var _a, _b, _c, _d, _e, _f;
            const key = getUniqKey(index, item);
            if (decorates[key]) {
                let ignore = false;
                if ((_b = (_a = decorates[key]) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.length) {
                    (_c = decorates[key]) === null || _c === void 0 ? void 0 : _c.bottom.forEach(item => {
                        if (!ignore) {
                            ignore = !!item.ignore;
                        }
                    });
                }
                if ((_e = (_d = decorates[key]) === null || _d === void 0 ? void 0 : _d.top) === null || _e === void 0 ? void 0 : _e.length) {
                    (_f = decorates[key]) === null || _f === void 0 ? void 0 : _f.top.forEach(item => {
                        if (!ignore) {
                            ignore = !!item.ignore;
                        }
                    });
                }
                if (!ignore) {
                    lock = null;
                    if (groupCollapseMap[key]) {
                        map[key] = groupCollapseMap[key];
                        lock = groupCollapseMap[key];
                    }
                }
                else {
                    if (lock) {
                        map[key] = lock;
                    }
                }
            }
            else {
                if (lock) {
                    map[key] = lock;
                }
            }
        });
        return map;
    }, [data, groupCollapseMap, decorates]);
    useEffect(() => {
        if (activeId && activeId.length == 1 && groupCollapse && groupCollapse.length > 0 && cardHiddenMap[activeId[0]]) {
            onGroupCollapseRef(cardHiddenMap[activeId[0]], false);
        }
    }, [activeId]);
    const localTopExtraData = useMemo(() => {
        if (!topExtraData || topExtraData.length === 0) {
            return [];
        }
        else {
            let localData = topExtraData.map(item => {
                return Object.assign(Object.assign({}, item), { height: item.height + cardMargin });
            });
            setTimeout(() => {
                topExtraData.forEach((_, index) => {
                    var _a;
                    if (listref && listref.current) {
                        (_a = listref.current) === null || _a === void 0 ? void 0 : _a.recomputeRowHeights(index);
                    }
                });
            }, 0);
            return localData;
        }
    }, [topExtraData]);
    const groupCollapseData = useMemo(() => {
        if (groupCollapseMap) {
            return data.filter((item, index) => {
                const key = getUniqKey(index, item);
                return !cardHiddenMap[key] || groupCollapseMap[key];
            });
        }
        return data;
    }, [data, groupCollapseMap, cardHiddenMap]);
    const getCardHeight = useCallback((params) => {
        var _a, _b, _c, _d;
        let { index, id } = params;
        const cardData = cardKey2SataMap[id] || groupCollapseData[index];
        id = getUniqKey(index, cardData);
        let decorateHeight = 0;
        if (decorates[id]) {
            (_b = (_a = decorates[id]) === null || _a === void 0 ? void 0 : _a.top) === null || _b === void 0 ? void 0 : _b.forEach(item => {
                decorateHeight += item.height;
            });
            (_d = (_c = decorates[id]) === null || _c === void 0 ? void 0 : _c.bottom) === null || _d === void 0 ? void 0 : _d.forEach(item => {
                decorateHeight += item.height;
            });
        }
        const rowContentHeight = groupCollapseMap[getUniqKey(index, cardData)] ? 0 : rowHeight(cardData);
        return rowContentHeight + cardMargin + decorateHeight;
    }, [rowHeight, cardMargin, decorates, listFouceRender, groupCollapseMap, cardKey2SataMap, groupCollapseData]);
    const groupCollapseTotal = useMemo(() => {
        if (total > 0) {
            const count = data.length - groupCollapseData.length;
            return total - count;
        }
        return total;
    }, [data, groupCollapseData, total]);
    const [preMailSumHeightMap, preMailSumHeightKeyMap, estimatedRowSize] = useMemo(() => {
        let preHeight = 0;
        const map = {};
        const keyMap = {};
        const defaultEstimatedRowSize = 90;
        let estimatedRowSize = defaultEstimatedRowSize;
        localTopExtraData.forEach(item => {
            preHeight += item.height;
        });
        groupCollapseData.forEach((item, index) => {
            const key = getUniqKey(index, item);
            map[index] = preHeight;
            keyMap[key] = preHeight;
            preHeight += getCardHeight({ index, id: key });
            if (index == groupCollapseData.length - 1) {
                try {
                    estimatedRowSize = preHeight / groupCollapseData.length;
                }
                catch (e) {
                    console.error('[error cardList OverScreen]', e);
                    estimatedRowSize = defaultEstimatedRowSize;
                }
            }
        });
        return [map, keyMap, estimatedRowSize];
    }, [groupCollapseData, localTopExtraData, getCardHeight]);
    const dataRef = useStateRef(data);
    const listScrollIsOver = useMemo(() => {
        try {
            if (groupCollapseData && groupCollapseData.length) {
                const sumHeight = preMailSumHeightMap[groupCollapseData.length - 1];
                return sumHeight > height;
            }
        }
        catch (e) {
            console.error('[error cardList OverScreen]', e);
        }
        return false;
    }, [groupCollapseData === null || groupCollapseData === void 0 ? void 0 : groupCollapseData.length, preMailSumHeightMap, height]);
    const measureCache = useMemo(() => new CellMeasurerCache({
        fixedWidth: true,
        minHeight: 70,
    }), [groupCollapseData, listFouceRender]);
    const key2DataIndex = useMemo(() => {
        const map = {};
        data.forEach((item, index) => {
            map[getUniqKey(index, item)] = index;
        });
        return map;
    }, [data]);
    const getOriginDataIndex = useCreateCallbackForEvent((key) => key2DataIndex[key]);
    const handleClick = useCallback((cardData, index, e) => {
        e === null || e === void 0 ? void 0 : e.persist();
        const originIndex = getOriginDataIndex(getUniqKey(index, cardData)) || index;
        onSelect && onSelect(getUniqKey(index, cardData), cardData, originIndex, e);
    }, [onSelect, getUniqKey]);
    const handleOnGroupSelect = useCreateCallbackForEvent((ckey, checked) => {
        if (decorates) {
            let startIndex = -1;
            for (let i = 0; i < data.length; i++) {
                const dataItem = data[i];
                const key = getUniqKey(i, dataItem);
                if (decorates[key]) {
                    const decorate = decorates[key];
                    if (decorate.top &&
                        decorate.top.find(item => {
                            return item.key == ckey;
                        })) {
                        startIndex = i;
                        break;
                    }
                    if (decorate.bottom &&
                        decorate.bottom.find(item => {
                            return item.key == ckey;
                        })) {
                        startIndex = i + 1;
                        break;
                    }
                }
            }
            let endIndex = startIndex;
            if (startIndex > -1) {
                for (let i = startIndex + 1; i < data.length; i++) {
                    const item = data[i];
                    const key = getUniqKey(i, item);
                    if (decorates[key]) {
                        const decorate = decorates[key];
                        if (decorate.top &&
                            decorate.top.find(item => {
                                return item.isCheckable;
                            })) {
                            endIndex = i;
                            break;
                        }
                        if (decorate.bottom &&
                            decorate.bottom.find(item => {
                                return item.isCheckable;
                            })) {
                            endIndex = i + 1;
                            break;
                        }
                    }
                    if (i == data.length - 1) {
                        endIndex = i + 1;
                    }
                }
            }
            if (data.length == 1 && endIndex == 0) {
                endIndex = endIndex + 1;
            }
            if (startIndex > -1 && endIndex > -1) {
                const rangeData = data.slice(startIndex, endIndex);
                const ids = rangeData.map((item, index) => {
                    return getUniqKey(startIndex + index, item);
                });
                if (checked) {
                    onSelect && onSelect(ids, rangeData, startIndex);
                }
                else {
                    onUnSelect && onUnSelect(ids, rangeData, startIndex);
                }
            }
        }
    });
    const cardCheckedMap = useMemo(() => {
        var _a, _b, _c, _d, _e, _f;
        const map = {};
        if (!isMultiple) {
            return {};
        }
        if (data && data.length) {
            let isCheckableKey;
            let dataIndex = 0;
            for (let index = 0; index < data.length; index++) {
                const item = data[index];
                const key = getUniqKey(index, item);
                if (decorates[key]) {
                    if ((_b = (_a = decorates[key]) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.length) {
                        (_c = decorates[key]) === null || _c === void 0 ? void 0 : _c.bottom.forEach((item, dindex) => {
                            if (item === null || item === void 0 ? void 0 : item.isCheckable) {
                                if (isCheckableKey && item.key != isCheckableKey && dataIndex != index) {
                                    map[isCheckableKey] = true;
                                }
                                isCheckableKey = item.key;
                                dataIndex = index;
                            }
                        });
                    }
                    if ((_e = (_d = decorates[key]) === null || _d === void 0 ? void 0 : _d.top) === null || _e === void 0 ? void 0 : _e.length) {
                        (_f = decorates[key]) === null || _f === void 0 ? void 0 : _f.top.forEach((item, dindex) => {
                            if (item === null || item === void 0 ? void 0 : item.isCheckable) {
                                if (isCheckableKey && item.key != isCheckableKey && dataIndex != index) {
                                    map[isCheckableKey] = true;
                                }
                                isCheckableKey = item.key;
                                dataIndex = index;
                            }
                        });
                    }
                }
                if (isCheckableKey) {
                    if (!activeIdMap[key]) {
                        isCheckableKey = null;
                    }
                }
                if (index == data.length - 1) {
                    if (isCheckableKey && activeIdMap[key]) {
                        map[isCheckableKey] = true;
                    }
                }
            }
        }
        return map;
    }, [activeIdMap, data, decorates, isMultiple]);
    const handleDoubleClick = useCallback((cardData, index, e) => {
        e === null || e === void 0 ? void 0 : e.persist();
        const originIndex = getOriginDataIndex(getUniqKey(index, cardData)) || index;
        onDoubleClick && onDoubleClick([getUniqKey(index, cardData)], cardData, originIndex, e);
    }, [onDoubleClick, getUniqKey]);
    const listItemClickProxy = useCallback(useSyncSingleAndDoubleClick(handleClick, handleDoubleClick, 200), []);
    const handleCardClick = useCallback((cardData, index, e) => {
        e === null || e === void 0 ? void 0 : e.persist();
        const originIndex = getOriginDataIndex(getUniqKey(index, cardData)) || index;
        listItemClickProxy(getUniqKey(index, cardData), cardData, originIndex, e);
    }, [listItemClickProxy, getUniqKey]);
    const handleCardClickCapture = useCallback((cardData, index, e) => {
        if (selectIsCapture && (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey)) {
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            e === null || e === void 0 ? void 0 : e.persist();
            const originIndex = getOriginDataIndex(getUniqKey(index, cardData)) || index;
            listItemClickProxy(getUniqKey(index, cardData), cardData, originIndex, e);
        }
    }, [listItemClickProxy, getUniqKey]);
    const handleContextMenu = useCallback((cardData, index, e) => {
        e === null || e === void 0 ? void 0 : e.persist();
        const originIndex = getOriginDataIndex(getUniqKey(index, cardData)) || index;
        onContextMenu && onContextMenu([getUniqKey(index, cardData)], cardData, originIndex, e);
    }, [onContextMenu, getUniqKey]);
    const handleCardChecked = useCallback((checked, cardData, index, e) => {
        e === null || e === void 0 ? void 0 : e.persist();
        const originIndex = getOriginDataIndex(getUniqKey(index, cardData)) || index;
        onChecked && onChecked(checked, [getUniqKey(index, cardData)], cardData, originIndex, e);
    }, [onChecked, getUniqKey]);
    const throttleScanFixedDec = useCallback(throttle(scrollTop => {
        let aimDec;
        fixedList.forEach(item => {
            if (item) {
                const { decorate, cardKey } = item;
                let aimSt = preMailSumHeightKeyMap[cardKey];
                if (aimSt <= 50) {
                    aimSt = 50;
                }
                if (scrollTop >= aimSt) {
                    aimDec = decorate;
                }
            }
        });
        setFixDec(aimDec);
    }, 300, {
        trailing: true,
        leading: true,
    }), [fixedList, preMailSumHeightKeyMap]);
    const handleOnListScroll = useCallback(arg => {
        const { scrollTop } = arg || {};
        scrollTopRef.current = scrollTop;
        throttleScanFixedDec(scrollTop);
        onScroll && onScroll(arg);
    }, [throttleScanFixedDec, onScroll]);
    const handleOnRealListScroll = useCallback(event => {
        if (event) {
            const scrollTop = event.target.scrollTop;
            scrollTopRef.current = scrollTop;
            throttleScanFixedDec(scrollTop);
            onScroll &&
                onScroll({
                    scrollTop,
                });
        }
    }, [throttleScanFixedDec, onScroll]);
    const handleOnRealListScrollRef = useCreateCallbackForEvent(handleOnRealListScroll);
    const getDecoratesElement = useCreateCallbackForEvent((decorate, cardKey, position = 'top', isFirst = false, isLast = false) => {
        if (decorate && decorate[cardKey]) {
            const list = decorate[cardKey][position];
            if (list) {
                return list
                    .filter(item => item.element || item.content != null)
                    .map(item => {
                    if (item.isFoldable) {
                        const isCollapse = groupCollapseMap[cardKey];
                        const element = item.element || item.content;
                        return (React.createElement("div", { className: `${styles.decoratesCollapseWrap} ${isFirst ? '' : styles.decoratesCollapseLine} ${isLast ? styles.decoratesCollapseLineLast : ''} ${isCollapse ? 'dc-collapsed' : ''} ${decoratesWrapClassName}`, onClick: () => onGroupCollapseRef((item === null || item === void 0 ? void 0 : item.key) || cardKey, !isCollapse) },
                            item.isCheckable ? (React.createElement("div", { className: "mc-checkbox-wrap" },
                                React.createElement(Checkbox, { checked: cardCheckedMap[item === null || item === void 0 ? void 0 : item.key], onChange: e => {
                                        e.stopPropagation();
                                        handleOnGroupSelect(item === null || item === void 0 ? void 0 : item.key, e.target.checked);
                                    }, onClick: e => {
                                        e.stopPropagation();
                                    } }))) : (React.createElement(React.Fragment, null)),
                            React.createElement("div", { className: `${styles.decoratesCollapseIcon}  ${isCollapse ? styles.decoratesCollapseIconActive : ''}` },
                                React.createElement(TongyongZhankaiXia, { width: 16, height: 16 })),
                            React.createElement("div", { className: styles.decoratesCollapseContent },
                                " ",
                                element)));
                    }
                    else {
                        if (item.element) {
                            return item.element;
                        }
                        else {
                            return React.createElement("div", { className: styles.decoratesCollapseWrap + '  ' + decoratesWrapClassName }, item.content);
                        }
                    }
                });
            }
        }
        return React.createElement(React.Fragment, null);
    });
    const RealRowRender = useCallback(({ index }) => {
        const cardData = groupCollapseData[index];
        const key = getUniqKey(index, cardData);
        const cardIsActive = !!activeIdMap[key];
        const cardIsChecked = isMultiple && cardIsActive;
        const isCollapse = groupCollapseMap[key];
        const isFirst = index === 0;
        const isLast = index === groupCollapseData.length - 1;
        return (React.createElement("div", { className: "mail-real-list-item", style: { margin: `${cardMargin ? cardMargin + 'px' : ''} 0` } },
            getDecoratesElement(decorates, key, 'top', isFirst, isLast),
            !isCollapse ? (React.createElement(CardWrap, { data: cardData, index: index, onClick: e => handleCardClick(cardData, index, e), onClickCapture: e => handleCardClickCapture(cardData, index, e), onContextMenu: e => handleContextMenu(cardData, index, e) },
                React.createElement(CardCom, { active: !!activeIdMap[getUniqKey(index, cardData)], checked: cardIsChecked, data: cardData, width: width, onChecked: (checked, e) => {
                        handleCardChecked(checked, cardData, index, e);
                    } }))) : (React.createElement(React.Fragment, null)),
            getDecoratesElement(decorates, key, 'bottom', isFirst, isLast)));
    }, [
        groupCollapseData,
        groupCollapseMap,
        activeIdMap,
        getUniqKey,
        isMultiple,
        decorates,
        handleCardClick,
        handleCardClickCapture,
        handleContextMenu,
        handleCardChecked,
        CardCom,
    ]);
    const rowRendere = useCallback(({ index, key, style, parent }) => {
        const cardData = groupCollapseData[index];
        const cardKey = getUniqKey(index, cardData);
        const cardIsActive = !!activeIdMap[cardKey];
        const cardIsChecked = isMultiple && cardIsActive;
        const isCollapse = groupCollapseMap[cardKey];
        const isFirst = index === 0;
        const isLast = index === groupCollapseData.length - 1;
        return (React.createElement(CellMeasurer, { cache: measureCache, columnIndex: 0, key: key, parent: parent, rowIndex: index },
            React.createElement("div", { key: key, style: style },
                getDecoratesElement(decorates, cardKey, 'top', isFirst, isLast),
                !isCollapse ? (React.createElement(CardWrap, { data: cardData, index: index, onClick: e => handleCardClick(cardData, index, e), onClickCapture: e => handleCardClickCapture(cardData, index, e), onContextMenu: e => handleContextMenu(cardData, index, e) },
                    React.createElement(CardCom, { active: !!activeIdMap[getUniqKey(index, cardData)], checked: cardIsChecked, data: cardData, width: width, onChecked: (checked, e) => {
                            handleCardChecked(checked, cardData, index, e);
                        } }))) : (React.createElement(React.Fragment, null)),
                getDecoratesElement(decorates, cardKey, 'bottom', isFirst, isLast))));
    }, [
        groupCollapseData,
        groupCollapseMap,
        activeIdMap,
        getUniqKey,
        isMultiple,
        decorates,
        handleCardClick,
        handleCardClickCapture,
        handleContextMenu,
        handleCardChecked,
        CardCom,
    ]);
    const checkOverTop = useCallback((index) => preMailSumHeightMap[index] <= scrollTopRef.current, [preMailSumHeightMap]);
    const checkOverBottom = useCallback((index) => preMailSumHeightMap[index] + rowHeight(groupCollapseData[index]) > scrollTopRef.current + height, [preMailSumHeightMap, height, groupCollapseData]);
    const getGroupCollapseDataIndex = useCreateCallbackForEvent(key => groupCollapseData.findIndex((item, _index) => getUniqKey(_index, item) === key));
    const getKeyByOrginIndex = useCreateCallbackForEvent((index) => getUniqKey(index, data[index]));
    const listScrollToTop = useCallback((index) => {
        const key = getKeyByOrginIndex(index);
        const _index = getGroupCollapseDataIndex(key);
        if (_index >= 0) {
            if (checkOverBottom(_index)) {
                listScrollToBottomRef(_index);
                return;
            }
            if (checkOverTop(_index)) {
                const st = preMailSumHeightMap[_index] || 0;
                scrollToPositionRef(st);
                onScroll &&
                    onScroll({
                        scrollTop: st,
                    });
            }
        }
        else {
            setTimeout(() => {
                const key = getKeyByOrginIndex(index);
                const _index = getGroupCollapseDataIndex(key);
                if (_index >= 0) {
                    if (checkOverBottom(_index)) {
                        listScrollToBottomRef(_index);
                        return;
                    }
                    if (checkOverTop(_index)) {
                        const st = preMailSumHeightMap[_index] || 0;
                        scrollToPositionRef(st);
                        onScroll &&
                            onScroll({
                                scrollTop: st,
                            });
                    }
                }
            }, 500);
        }
    }, [checkOverBottom, checkOverTop, onScroll, preMailSumHeightMap, data, groupCollapseData, getUniqKey]);
    const listScrollToBottom = useCallback((index) => {
        const key = getKeyByOrginIndex(index);
        const _index = getGroupCollapseDataIndex(key);
        if (_index >= 0) {
            if (checkOverTop(_index)) {
                listScrollToTopRef(_index);
                return;
            }
            if (checkOverBottom(_index)) {
                const st = preMailSumHeightMap[_index] - height + rowHeight(groupCollapseData[_index]) + 24;
                scrollToPositionRef(st);
                onScroll &&
                    onScroll({
                        scrollTop: st,
                    });
            }
        }
        else {
            setTimeout(() => {
                const key = getKeyByOrginIndex(index);
                const _index = getGroupCollapseDataIndex(key);
                if (_index >= 0) {
                    if (checkOverTop(_index)) {
                        listScrollToTopRef(_index);
                        return;
                    }
                    if (checkOverBottom(_index)) {
                        const st = preMailSumHeightMap[_index] - height + rowHeight(groupCollapseData[_index]) + 24;
                        scrollToPositionRef(st);
                        onScroll &&
                            onScroll({
                                scrollTop: st,
                            });
                    }
                }
            }, 500);
        }
    }, [checkOverBottom, checkOverTop, onScroll, preMailSumHeightMap, rowHeight, height, groupCollapseData, data, getUniqKey]);
    const scrollToPosition = useCallback(debounce(scrollTop => {
        scrollToPositionRef(scrollTop);
    }, 200), []);
    const listScrollToTopRef = useCreateCallbackForEvent(listScrollToTop);
    const listScrollToBottomRef = useCreateCallbackForEvent(listScrollToBottom);
    const listScrollToPositionRef = useCreateCallbackForEvent(scrollToPosition);
    useImperativeHandle(ref, () => ({
        scrollToTop: listScrollToTopRef,
        srollToBottom: listScrollToBottomRef,
        scrollToPosition: listScrollToPositionRef,
    }), [listScrollToTopRef, listScrollToBottomRef]);
    const fixedDecElement = useMemo(() => {
        var _a, _b, _c;
        if (!fixDec) {
            return React.createElement(React.Fragment, null);
        }
        const fixedConfigIsObj = typeof (fixDec === null || fixDec === void 0 ? void 0 : fixDec.fixed) === 'object';
        const decStyle = fixedConfigIsObj ? ((_a = fixDec === null || fixDec === void 0 ? void 0 : fixDec.fixed) === null || _a === void 0 ? void 0 : _a.style) || {} : {};
        const decHeight = fixedConfigIsObj ? (_b = fixDec === null || fixDec === void 0 ? void 0 : fixDec.fixed) === null || _b === void 0 ? void 0 : _b.height : fixDec === null || fixDec === void 0 ? void 0 : fixDec.height;
        const devElement = fixedConfigIsObj ? fixDec === null || fixDec === void 0 ? void 0 : fixDec.element : (_c = fixDec === null || fixDec === void 0 ? void 0 : fixDec.fixed) === null || _c === void 0 ? void 0 : _c.element;
        const contentElement = React.createElement("div", { className: styles.fixedDecorateWrap }, fixDec.content);
        return (React.createElement("div", { className: styles.cardlistFixedTopWrap, hidden: !fixDec, style: Object.assign({ height: decHeight }, decStyle) }, devElement || contentElement));
    }, [fixDec]);
    const handleContentInsufficientHeight = useDebounceForEvent(() => {
        if (onContentInsufficientHeight && typeof onContentInsufficientHeight == 'function') {
            onContentInsufficientHeight();
        }
    }, 1000, {
        leading: false,
    });
    const contentSumHeight = useMemo(() => {
        if (preMailSumHeightMap) {
            return preMailSumHeightMap[groupCollapseData.length - 1];
        }
        return 0;
    }, [preMailSumHeightMap, groupCollapseData]);
    useUpdateEffect(() => {
        try {
            if (contentSumHeight != null && dataRef.current) {
                if (contentSumHeight < height) {
                    handleContentInsufficientHeight();
                }
            }
        }
        catch (e) {
            console.error('[error cardList OverScreen]', e);
        }
    }, [height, dataKey, contentSumHeight]);
    const localClassName = useMemo(() => {
        try {
            if (className) {
                if (typeof className == 'string') {
                    return className + '  ' + (listScrollIsOver ? SCROLL_OVER_CLASSNAME : '') + '  ' + (useRealList ? DEFAULT_REAL_LIST_CLASSNAME : '');
                }
                else if (typeof className == 'object') {
                    return Object.assign(Object.assign({}, className), { [SCROLL_OVER_CLASSNAME]: listScrollIsOver, [DEFAULT_REAL_LIST_CLASSNAME]: useRealList });
                }
            }
        }
        catch (e) {
            console.error('[error cardList OverScreen]', e);
        }
        return listScrollIsOver ? SCROLL_OVER_CLASSNAME : '';
    }, [className, listScrollIsOver, useRealList]);
    const RealRowRenderRef = useCreateCallbackForEvent(RealRowRender);
    const onLoadMoreProxy = useCreateCallbackForEvent((start) => {
        if (onLoadMore) {
            return onLoadMore(data.length);
        }
    });
    const ListElement = useMemo(() => {
        return useRealList ? (React.createElement("div", { className: localClassName, onScroll: handleOnRealListScrollRef, ref: realListRef, style: { width: '100%', padding: '5px 0', height: height, overflow: 'auto' } },
            groupCollapseData.map((_, inx) => {
                return RealRowRenderRef({ index: inx });
            }),
            realListPager)) : (React.createElement(List, { ref: listref, data: groupCollapseData, isRefresh: isRefresh, width: width, total: groupCollapseTotal, rowHeight: getCardHeight, height: height, onScroll: handleOnListScroll, rowRenderer: rowRendere, initLoadMore: false, topExtraData: localTopExtraData, overscanRowCount: 20, scrollingResetTimeInterval: 300, defaultScrollTop: scrollTop, batchSize: batchSize, threshold: threshold, containerStyle: containerStyle, className: localClassName, pullRefreshLoadingHeight: pullRefreshLoadingHeight, loadMoreLoadingHeight: loadMoreLoadingHeight, noMoreRender: noMoreRender, pullRefreshRender: pullRefreshRender, loadMoreLoadingRender: loadMoreLoadingRender, noRowsRenderer: noRowsRenderer, onPullRefresh: onPullRefresh, onLoadMore: onLoadMoreProxy, loadMoreLoadingFailRender: loadMoreLoadingFailRender, initLoadLoadingFailRender: initLoadLoadingFailRender, estimatedRowSize: estimatedRowSize }));
    }, [
        groupCollapseData,
        width,
        height,
        groupCollapseTotal,
        getCardHeight,
        batchSize,
        threshold,
        containerStyle,
        localClassName,
        overscanRowCount,
        topExtraData,
        pullRefreshLoadingHeight,
        loadMoreLoadingHeight,
        onScroll,
        noMoreRender,
        pullRefreshRender,
        loadMoreLoadingRender,
        noRowsRenderer,
        onPullRefresh,
        loadMoreLoadingFailRender,
        initLoadLoadingFailRender,
        rowRendere,
        useRealList,
        isRefresh,
    ]);
    return (React.createElement("div", { className: styles.cardlistWrap },
        ListElement,
        fixedDecElement));
}
export default forwardRef(CardList);
